import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import { CalendarOneIcon, ClockIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

interface DateChipProps {
  date: Date
  label: string
}

const DateChip: React.FC<DateChipProps> = ({ date, label }) => {
  return (
    <div className="rounded flex flex-row items-center bg-grey-light w-fit">
      <div className="flex flex-row items-center gap-2 p-3 border-r border-grey-light-hover">
        <CalendarOneIcon color={tailwindColors.grey.lighter} />
        <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
          {label}
        </Typography>
      </div>

      <div className="flex flex-row items-center gap-4 p-3">
        <Typography variant="label-semibold">{DateFormatter.DDMMYYYY(date)}</Typography>

        <div className="flex items-center gap-1">
          <ClockIcon />
          <Typography variant="label" style={{ lineHeight: '12px' }}>
            {DateFormatter.HHmm(date)}
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default DateChip
